<template lang="pug">
article.episode-card.media
  figure.media-left
    router-link(:to="{ name: 'episode', params: { id: episode.id } }")
      b-icon.premium-icon(icon="lock" v-if="episode.is_premium")
      b-icon.play-icon(icon="play-circle-outline" size="is-large")
      cl-img(
        :cl-id="episode._embedded.artwork.cl_id"
        :transform="{ width: 640, height: 360 }"
      )
  .media-content
    .content
      h2.is-size-4
        router-link(:to="{ name: 'episode', params: { id: episode.id } }") {{ episode.title }}
      p.has-text-grey {{ episode.pub_date | date('dddd MMMM D, YYYY') }}
      read-more(:value="episode.long_desc" :length="180")
</template>

<script>
import ReadMore from '@/components/ReadMore.vue';

export default {
  name: 'episode-card',
  components: {
    ReadMore,
  },
  computed: {
    episode() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.episode-card {
  background-color: $white;
  padding-top: 0 !important;
  transform: translate3d(0,0,0);
  transition: transform 0.35s ease-in-out, box-shadow 0.35s ease-in-out;
  &:hover {
    // transform: translate3d(7px,0,0);
    // box-shadow: 0 3px 30px rgba(0,0,0,0.15);
    figure.media-left {
      .icon {
        opacity: 1.0;
      }
      img {
        opacity: 0.5;
      }
    }
  }
  & + .episode-card {
    margin-top: 1.5rem !important;
  }
  figure.media-left {
    background-color: $black-bis;
    position: relative;
    .premium-icon {
      position: absolute;
      color: $white;
      top: 12px;
      right: 12px;
      z-index: 1;
    }
    .play-icon {
      position: absolute;
      color: $white;
      top: 50%;
      left: 50%;
      margin-top: -24px;
      margin-left: -24px;
      z-index: 1;
      transition: 0.25s opacity ease-in-out;
      opacity: 0.0;
    }
    img {
      max-width: 400px;
      transition: 0.35s opacity ease-in-out;
      opacity: 1.0;
    }
  }
  .content {
    padding: 1.5rem 1.5rem 1.5rem 0.5rem;
    h2 {
      a {
        color: $grey-darker;
      }
    }
  }
}
</style>
